import { ServiceFetch } from '../service-fetch'

export default class ExpensesNoteListModel extends ServiceFetch {
    getExpensesNoteListBy = (data) => this.authFetch({
        url: 'expenses-note-list/getExpensesNoteListBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}